import CardsList from "./cardsList";
const Cards = ({global,initialData}) => {
  return (
    <section className="cards-section">
      <div className="wrapper">
      <div className="cards">
        <h2 className="cards__title">{global.localization.cardsLabelHome}</h2>
        <CardsList list={initialData.cards}/>
      </div>
      </div>
    </section>
  );
};

export default Cards;
